import { render } from "./LabelGroup.vue?vue&type=template&id=42c0d1dd"
import script from "./LabelGroup.vue?vue&type=script&lang=js"
export * from "./LabelGroup.vue?vue&type=script&lang=js"

import "./LabelGroup.vue?vue&type=style&index=0&id=42c0d1dd&lang=scss"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__